"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SessionManager_1 = require("./SessionManager");
exports.SessionContext = react_1.default.createContext(undefined);
// Legacy name
exports.AuthContext = exports.SessionContext;
exports.LoggedOutReasons = {
    None: null,
    Timeout: "timeout"
};
var SessionProvider = /** @class */ (function (_super) {
    __extends(SessionProvider, _super);
    function SessionProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.lastUserInteraction = Date.now();
        _this.handleUserInteraction = function () { return (_this.lastUserInteraction = Date.now()); };
        _this.handleSessionTimeoutCheck = function () {
            // default to not use local session timeout
            if (!_this.props.localSessionTimeout) {
                return;
            }
            if (_this.state.user &&
                _this.lastUserInteraction < Date.now() - _this.props.localSessionTimeout * 1000) {
                _this.setState({ loggingOut: true });
                _this.sessionManager.logout({
                    hash: window.location.hash,
                    pathname: window.location.pathname,
                    search: window.location.search,
                    state: window.history.state
                }, exports.LoggedOutReasons.Timeout);
            }
        };
        _this.handleUserChanged = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateUser()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleLogoutRequest = function (reason, postLogoutLocation) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loggingOut: true });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sessionManager.logout(postLogoutLocation, reason || exports.LoggedOutReasons.None)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Failed to start logout: ", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleLoginRequest = function (args) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.sessionManager.login(args)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Failed to start login: ", error_2);
                        this.setState({ error: true });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.updateUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var newUser, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 1, , 3]);
                        newUser = this.sessionManager.getUser();
                        this.lastUserInteraction = Date.now();
                        if (this.props.onUserUpdated) {
                            this.props.onUserUpdated(newUser);
                        }
                        this.setState({ user: newUser, initialized: true });
                        return [3 /*break*/, 3];
                    case 1:
                        error_3 = _a.sent();
                        console.error("Failed to setup user context.", error_3);
                        this.setState({ error: true, initialized: true });
                        return [4 /*yield*/, this.sessionManager.dropUser()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.state = { loggedOutReason: exports.LoggedOutReasons.None };
        _this.sessionManager = new SessionManager_1.SessionManager({
            clientId: props.clientId,
            environment: props.environment,
            scope: props.scope,
            basePath: props.basePath,
            automaticSilentRenew: props.automaticSilentRenew,
            navigate: props.navigate
        });
        return _this;
    }
    SessionProvider.prototype.render = function () {
        var value = {
            error: this.state.error,
            loading: !this.state.initialized || this.state.loggingOut,
            loggedOutReason: this.state.loggedOutReason,
            user: this.state.user,
            logout: this.handleLogoutRequest,
            login: this.handleLoginRequest,
            manager: this.sessionManager
        };
        var children = this.props.children;
        return (react_1.default.createElement(exports.AuthContext.Provider, { value: value }, typeof children === "function" ? children(value) : children));
    };
    SessionProvider.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_4, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Give the app some heavy feeling :)
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 500); })];
                    case 1:
                        // Give the app some heavy feeling :)
                        _a.sent();
                        // Wire up local timeout check
                        this.lastUserInteraction = Date.now();
                        window.addEventListener("mousemove", this.handleUserInteraction);
                        window.addEventListener("touchstart", this.handleUserInteraction);
                        window.setInterval(this.handleSessionTimeoutCheck, 10000);
                        // Sign up for user changed
                        this.sessionManager.addUserChangedListener(this.handleUserChanged);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.sessionManager.initialize()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_4 = _a.sent();
                        console.error("Failed to initialize session manager: ", error_4);
                        this.setState({ error: true });
                        return [3 /*break*/, 5];
                    case 5:
                        if (!!this.sessionManager.getUser()) return [3 /*break*/, 12];
                        if (!(this.props.autoLogin && !this.sessionManager.getLoggedOutReason())) return [3 /*break*/, 10];
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this.sessionManager.login()];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        error_5 = _a.sent();
                        console.error("Failed to login.", error_5);
                        this.setState({ error: true, initialized: true });
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        this.setState({
                            initialized: true,
                            loggedOutReason: this.sessionManager.getLoggedOutReason()
                        });
                        _a.label = 11;
                    case 11: return [3 /*break*/, 14];
                    case 12: return [4 /*yield*/, this.updateUser()];
                    case 13:
                        _a.sent();
                        _a.label = 14;
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    return SessionProvider;
}(react_1.default.Component));
exports.SessionProvider = SessionProvider;
//# sourceMappingURL=SessionProvider.js.map